import { $, _ } from "js/vendor";
import React, { Component } from "reactn";
import { FeatureType } from "../../../../core/models/features";
import { app } from "js/namespaces";
import { getStaticUrl } from "js/config";
import { Fragment } from "react";
import { PresentationPrivacyType } from "js/core/models/presentation";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";
import ProBadge from "js/react/components/ProBadge";
import "css/player-settings.scss";
import { Section, UIPane, UIPaneContents, UIPaneHeader } from "js/react/components/UiComponents";
import shouldShowProBadge from "js/editor/shouldShowProBadge";
import { AssetType, TaskState, TaskType } from "common/constants";
import getUserProfile from "js/core/services/userProfiles";
import { BlueSwitch } from "js/react/components/Switch";
import { ShowUpgradeDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { Divider, Tooltip } from "@material-ui/core";
import { ds } from "js/core/models/dataService";
import log from "js/core/logger";
import { uploadFileAndCreateTask } from "js/core/services/tasks";
import styled from "styled-components";
import PlayerControls from "js/react/views/Player/Components/PlayerControls";
import { PlayerBranding } from "js/react/views/Player/Components/PlayerView";
import PlayerInfoBar from "js/react/views/Player/Components/PlayerInfoBar";
import EndPage from "js/react/views/Player/Components/EndPage";

const MoreMenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoreMenu = styled.div`
  position: absolute;
  bottom: 100%;
  background: rgba(0, 0, 0, 0.75);
  padding: 2px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const MoreMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #ccc;
  padding: 4px 0;
  white-space: nowrap;

  .micon {
    margin-right: 4px !important;
  }
`;

export class PlayerPreview extends Component {
    constructor() {
        super();
        this.state = {
            author: null,
            previewType: "player"
        };

        this.endPageRef = React.createRef();
    }

    renderAuthor(author, showTitle, showAuthor) {
        if (showAuthor && author) {
            return (
                <Fragment>
                    {!showTitle && <div style={{ flexGrow: 2 }}></div>}
                    <div className="author-photo">
                        {author.photoURL ? <img src={author.photoURL}/> : null}
                        {author.displayName ? author.displayName : ""}
                    </div>
                </Fragment>
            );
        } else {
            return;
        }
    }

    async componentDidMount() {
        const { presentation } = this.global;
        let author = await getUserProfile(this.global.presentation.get("userId"));
        let slideThumbnail = await presentation.getThumbnailUrl(null, "large");
        this.setState({ author, slideThumbnail });
    }

    render() {
        const { presentation } = this.global;

        let preview;

        switch (this.state.previewType) {
            case "player":
                preview = this.renderFullPlayer();
                break;
            case "end":
                preview = this.renderEndOfPresentation();
                break;
        }

        return (
            <div className="player-preview-frame">
                {preview}

                <div className="toggle-buttons">
                    <div
                        className={this.state.previewType == "player" ? "selected" : ""}
                        onClick={() => this.setState({ previewType: "player" })}
                    >
                        Player
                    </div>
                    <div
                        className={this.state.previewType == "end" ? "selected" : ""}
                        onClick={() => this.setState({ previewType: "end" })}
                    >
                        End of Presentation
                    </div>
                </div>
            </div>
        );
    }

    renderEndOfPresentation() {
        const { presentation } = this.global;

        const privacySetting = presentation.getPrivacySetting();

        let showBranding = app.user.features.isFeatureEnabled(FeatureType.PLAYER_SETTINGS, presentation.getWorkspaceId()) == false;
        let allowSocialSharing = presentation.get("showSocialSharing") && privacySetting == PresentationPrivacyType.PUBLIC;
        let allowCopyDeck = presentation.get("showGetDeckUI") && privacySetting == PresentationPrivacyType.PUBLIC;
        let allowPdfDownload = presentation.get("allowPdfDownload") && privacySetting !== PresentationPrivacyType.PRIVATE;

        return (
            <div className="end_banner player-preview">
                <EndPage
                    showBranding={showBranding}
                    presentation={presentation}
                    creator={{
                        displayName: app.user.getDisplayName(),
                        photoURL: app.user.getAvatarUrl()
                    }}
                    isLoggedIn={false}
                    isPlayerSettingsPreview
                    allowSocialSharing={allowSocialSharing}
                    onCopyDeck={allowCopyDeck ? () => { } : false}
                    allowCopyLink
                    onDownloadPdf={allowPdfDownload ? () => { } : false}
                />
            </div>
        );
    }

    showControls = () => {
        this.setState({ showControls: true });

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        this.timeout = setTimeout(() => {
            this.setState({ showControls: false });
            this.timeout = null;
        }, 1000);
    }

    handleToggleActionsMenu = value => {
        this.setState({ actionsMenuIsOpen: value });
    }

    renderFullPlayer() {
        const { presentation } = this.global;
        const { slideThumbnail, showControls, actionsMenuIsOpen } = this.state;

        const privacySetting = presentation.getPrivacySetting();

        let showBranding = app.user.features.isFeatureEnabled(FeatureType.PLAYER_SETTINGS, presentation.getWorkspaceId()) == false;
        let allowSocialSharing = presentation.get("showSocialSharing") && privacySetting == PresentationPrivacyType.PUBLIC;
        let allowCopyDeck = presentation.get("showGetDeckUI") && privacySetting == PresentationPrivacyType.PUBLIC;
        let allowPdfDownload = presentation.get("allowPdfDownload") && privacySetting !== PresentationPrivacyType.PRIVATE;

        return (
            <div className="player-preview full-player" onMouseMove={this.showControls}>
                {showBranding &&
                <PlayerBranding isLoggedIn={false}/>
                }
                <div className="slide-preview" style={{ height: showBranding ? "calc(100% - 50px)" : "100%" }}>
                    <img className="slide-thumbnail" src={slideThumbnail}/>
                    {showBranding && (
                        <div className="slide-watermark">
                            <img src={getStaticUrl(`/images/beautifulai-logos/watermark.svg`)}/>
                        </div>
                    )}
                    <PlayerInfoBar
                        visible={showControls}
                        presentation={presentation}
                        creator={{
                            displayName: app.user.getDisplayName(),
                            photoURL: app.user.getAvatarUrl()
                        }}
                    />
                    <PlayerControls
                        visible={showControls}
                        actionsMenuIsOpen={actionsMenuIsOpen}
                        onToggleActionsMenu={this.handleToggleActionsMenu}
                        showBranding={showBranding}
                        presentation={presentation}
                        currentSlideIndex={0}
                        isLoggedIn={false}
                        allowSocialSharing={allowSocialSharing}
                        onCopyDeck={allowCopyDeck ? () => {} : false}
                        allowCopyLink
                        onEditPresentation={false}
                        onDownloadPdf={allowPdfDownload ? () => { } : false}
                        advanceToSlide={() => { }}
                        isPlayerSettingsPreview
                    />
                </div>
            </div>
        );
    }
}

export default class PlayerSettingsPane extends Component {
    constructor() {
        super();
        const { presentation } = this.global;
        const privacySetting = presentation.getPrivacySetting();

        this.state = {
            featureEnabled: app.user.features.isFeatureEnabled(FeatureType.PLAYER_SETTINGS, presentation.getWorkspaceId()),
            privacySetting,
            removeBeautifulBranding: app.user.features.isFeatureEnabled(FeatureType.PLAYER_SETTINGS, presentation.getWorkspaceId()),

            showTitle: presentation.get("showTitle"),
            showAuthor: presentation.get("showAuthor"),
            requireEmail: presentation.get("requireEmail") && privacySetting !== PresentationPrivacyType.PRIVATE,
            showSocialSharing: presentation.get("showSocialSharing") && privacySetting == PresentationPrivacyType.PUBLIC,
            showGetDeckUI: presentation.get("showGetDeckUI") && privacySetting === PresentationPrivacyType.PUBLIC,
            allowPdfDownload: presentation.get("allowPdfDownload") && privacySetting !== PresentationPrivacyType.PRIVATE,

            autoPlay: presentation.get("autoPlay"),
            autoPlayDuration: presentation.get("autoPlayDuration") || 5,
            autoLoop: presentation.get("autoLoop"),
            hasAudio: presentation.has("audioAsset"),
            isPlayingAudio: false,
            isImportingAudio: false
        };

        this.fileInputRef = React.createRef();

        if (presentation.has("audioAsset")) {
            this.loadAudio();
        }
    }

    showUpgradeDialog = event => {
        if (!this.state.featureEnabled) {
            event.preventDefault();
            ShowUpgradeDialog({
                type: UpgradePlanDialogType.UPGRADE_PLAN,
                analytics: { cta: "Player Settings", ...this.global.presentation.getAnalytics() },
                workspaceId: this.global.presentation.getWorkspaceId()
            });
        }
    };

    handleChange = (value, id) => {
        if (this.state.featureEnabled) {
            const { presentation } = this.global;
            presentation.update({ [id]: value });
            this.setState({ [id]: value });
        }
    };

    handleChangeInput = (property, value) => {
        if (this.state.featureEnabled) {
            this.global.presentation.update({ [property]: value });
            this.setState({ [property]: value });
        }
    };

    componentDidMount() {
        _.defer(() => {
            this.updatePreview();
        });
        $(window).on("resize.playersettings", () => {
            this.updatePreview();
        });
    }

    componentDidUpdate() {
        this.updatePreview();
    }

    componentWillUnmount() {
        $(window).off(".playersettings");
    }

    updatePreview() {
        let scale = Math.min(
            ($(".player_settings").width() - 360) / 1280,
            (Math.min(window.innerHeight, 768) - 230) / 720
        );
        $(".player-preview").css("transform", `scale(${scale})`);
        $(".player-preview-frame")
            .width(1280 * scale)
            .height(720 * scale + 30);
    }

    loadAudio = async () => {
        try {
            const { presentation } = this.global;

            const audioAssetId = presentation.get("audioAsset");
            if (!audioAssetId) {
                return;
            }

            const asset = await ds.assets.getAssetById(audioAssetId, AssetType.AUDIO);
            const audioUrl = await asset.getBaseUrl(true);
            const audioName = asset.get("name");

            this.setState({ hasAudio: true, audioUrl, audioName });

            return audioUrl;
        } catch (err) {
            log.error(err);
        }
    }

    onAudioFinishedPlaying = () => {
        this.setState({ isPlayingAudio: false });
    }

    handlePlayAudio = async () => {
        let audioUrl = await this.loadAudio();
        this.setState({ isPlayingAudio: true });

        this.audio = new Audio(audioUrl);
        this.audio.play();
    }

    handleStopAudio = () => {
        this.audio && this.audio.pause();
        this.audio = null;
        this.setState({ isPlayingAudio: false });
    }

    handleImportAudio = () => {
        this.fileInputRef.current.click();
    }

    handleDeleteAudio = () => {
        const { presentation } = this.global;

        this.handleStopAudio();
        presentation.update({
            audioAsset: null
        });

        this.setState({
            hasAudio: false,
            audioName: null
        });
    }

    handleFileSelected = async event => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        this.setState({ isImportingAudio: true });
        await this.uploadAndTranscodeAudio(file);
        this.loadAudio();
        this.setState({ isImportingAudio: false });
    }

    uploadAndTranscodeAudio = async file => {
        const { presentation } = this.global;

        let assetId;
        try {
            assetId = await new Promise((resolve, reject) => {
                uploadFileAndCreateTask(
                    file,
                    TaskType.AUDIO_UPLOAD,
                    task => {
                        switch (task.state) {
                            case TaskState.ERROR:
                                return reject(new Error(task.errorMessage));
                            case TaskState.FINISHED:
                                resolve(task.assetId);
                        }
                    },
                    {
                        name: file.name.includes(".") ? file.name.split(".").slice(null, -1).join(".") : file.name
                    })
                    .catch(err => reject(err));
            });
        } catch (err) {
            ShowWarningDialog({
                title: "Failed to process audio",
                message: err.message
            });
            return;
        }

        presentation.update({
            audioAsset: assetId
        });
    }

    render() {
        const {
            featureEnabled,
            privacySetting,
            removeBeautifulBranding,
            allowPresenterNotes,
            requireEmail,
            showSocialSharing,
            showGetDeckUI,
            allowPdfDownload,
            description,
            showTitle,
            showAuthor,
            showSlideNotes,
            autoPlay,
            autoPlayDuration,
            autoLoop,
            hasAudio,
            audioName,
            isImportingAudio,
            isPlayingAudio
        } = this.state;

        return (
            <UIPane className="player_settings">
                <UIPaneHeader>
                    Player Settings
                    <ProBadge
                        show={shouldShowProBadge(FeatureType.PLAYER_SETTINGS, this.global.presentation.getWorkspaceId())}
                        analytics={{ cta: "Player Settings", ...this.global.presentation.getAnalytics() }}
                        workspaceId={this.global.presentation.getWorkspaceId()}
                    />
                </UIPaneHeader>
                <UIPaneContents>
                    <Section>
                        <div className="contents-frame">
                            <div
                                onClick={event => {
                                    this.showUpgradeDialog(event);
                                }}
                                className="switchContainer"
                            >
                                {!removeBeautifulBranding && (
                                    <Fragment>
                                        <BlueSwitch
                                            id="removeBeautifulBranding"
                                            checked={!removeBeautifulBranding}
                                            onChange={() => this.handleChange(!removeBeautifulBranding, "removeBeautifulBranding")}
                                            label="Show Beautiful.ai branding"
                                            tooltipTitle="Removes Beautiful.ai branding and call-to-actions from shared and embedded presentations."
                                        />
                                        <Divider/>
                                    </Fragment>
                                )}

                                <BlueSwitch
                                    id="showTitle"
                                    checked={showTitle}
                                    onChange={() => this.handleChange(!showTitle, "showTitle")}
                                    label="Show Title"
                                    tooltipTitle="Controls the visibility of the presentation title in shared presentation links."
                                />

                                <BlueSwitch
                                    id="showAuthor"
                                    checked={showAuthor}
                                    onChange={() => this.handleChange(!showAuthor, "showAuthor")}
                                    label="Show Author"
                                    tooltipTitle="Controls the visibility of the presentation author name in shared presentation links."
                                />

                                <BlueSwitch
                                    id="requireEmail"
                                    checked={requireEmail}
                                    onChange={() => this.handleChange(!requireEmail, "requireEmail")}
                                    label="Require Email"
                                    tooltipTitle="Controls whether anonymous viewers must provide an email for analytics."
                                    disabled={privacySetting === PresentationPrivacyType.PRIVATE}
                                />

                                <BlueSwitch
                                    id="showSocialSharing"
                                    checked={showSocialSharing}
                                    onChange={() => this.handleChange(!showSocialSharing, "showSocialSharing")}
                                    label="Allow Social Sharing"
                                    tooltipTitle="Controls whether viewers of a presentation can share on social networks. This option is disabled for private or secured presentations."
                                    disabled={privacySetting !== PresentationPrivacyType.PUBLIC}
                                />

                                <BlueSwitch
                                    id="showGetDeckUI"
                                    checked={showGetDeckUI}
                                    onChange={() => this.handleChange(!showGetDeckUI, "showGetDeckUI")}
                                    label="Allow Copying Deck"
                                    tooltipTitle="Controls whether viewers can make a copy of the presentation to use as a template for their presentations. This option is disabled for private or secured presentations."
                                    disabled={privacySetting !== PresentationPrivacyType.PUBLIC}
                                />

                                <BlueSwitch
                                    id="allowPdfDownload"
                                    checked={allowPdfDownload}
                                    onChange={() => this.handleChange(!allowPdfDownload, "allowPdfDownload")}
                                    label="Allow PDF Download"
                                    tooltipTitle="Controls whether viewers can download the presentation as a PDF. This option is disabled for private presentations."
                                    disabled={privacySetting === PresentationPrivacyType.PRIVATE}
                                />

                                <Divider/>

                                <BlueSwitch
                                    id="autoPlay"
                                    checked={autoPlay}
                                    onChange={() => this.handleChange(!autoPlay, "autoPlay")}
                                    label="Auto advance slides"
                                />

                                <Tooltip title="Sets how many seconds to wait before automatically advancing to the next slide. Specific delay settings on a slide will override this duration.">
                                    <div className="inset-control">
                                        <div className="small-label">After</div>
                                        <input
                                            disabled={!autoPlay}
                                            type="number"
                                            min="1"
                                            max="3600"
                                            step="1"
                                            value={autoPlayDuration}
                                            onChange={event =>
                                                this.handleChangeInput("autoPlayDuration", event.target.value)
                                            }
                                        />
                                        <div className="small-label">seconds</div>
                                    </div>
                                </Tooltip>

                                <BlueSwitch
                                    id="autoLoop"
                                    checked={autoLoop}
                                    onChange={() => this.handleChange(!autoLoop, "autoLoop")}
                                    label="Loop playback"
                                    tooltipTitle="Viewer analytics are not available when this setting is enabled."
                                />

                                {/*<Divider />*/}

                                {/*<Gap20 />*/}
                                {/*<label>Play Soundtrack</label>*/}
                                {/*<Gap10 />*/}
                                {/*{hasAudio &&*/}
                                {/*    <AudioPreview>*/}
                                {/*        {!isPlayingAudio &&*/}
                                {/*            <IconButton size="small" onClick={this.handlePlayAudio}>*/}
                                {/*                <Icon>play_circle</Icon>*/}
                                {/*            </IconButton>*/}
                                {/*        }*/}
                                {/*        {isPlayingAudio &&*/}
                                {/*            <IconButton size="small" onClick={this.handleStopAudio}>*/}
                                {/*                <Icon>stop</Icon>*/}
                                {/*            </IconButton>*/}
                                {/*        }*/}
                                {/*        <Gap10 />*/}
                                {/*        {audioName}*/}
                                {/*        <Gap10 />*/}
                                {/*        <IconButton size="small" onClick={this.handleDeleteAudio}><Icon>close</Icon></IconButton>*/}
                                {/*    </AudioPreview>*/}
                                {/*}*/}
                                {/*{!hasAudio &&*/}
                                {/*    <FlexBox left middle>*/}
                                {/*        <DarkButton*/}
                                {/*            size="small"*/}
                                {/*            disabled={isPlayingAudio || isImportingAudio}*/}
                                {/*            onClick={this.handleImportAudio}*/}
                                {/*            disableRipple={true}*/}
                                {/*        >*/}
                                {/*            {isImportingAudio && <CircularProgress size={20} />}*/}
                                {/*            {!isImportingAudio && <Icon>upload</Icon>}*/}
                                {/*            {isImportingAudio ? "Importing " : "Import "}audio...*/}
                                {/*        </DarkButton>*/}
                                {/*        <input*/}
                                {/*            ref={this.fileInputRef}*/}
                                {/*            type="file"*/}
                                {/*            hidden*/}
                                {/*            accept="audio/*"*/}
                                {/*            onChange={this.handleFileSelected}*/}
                                {/*        />*/}
                                {/*    </FlexBox>*/}
                                {/*}*/}
                            </div>
                            <PlayerPreview/>
                        </div>
                    </Section>
                </UIPaneContents>
            </UIPane>
        );
    }
}

const AudioPreview = styled.div`
  background: #eee;
  color: black;
  padding: 6px 8px;
  display: inline-flex;
  align-items: center;
`;
